<template>
    <div>
        <label for="institution-group" class="small is-block">{{ label }}*</label>
        <div class="select">
            <select id="institution-group" required
                    :value="selectedGroup" @change="$emit('update:selectedGroup', $event.target.value)"
            >
                <option disabled value="">Bitte auswählen</option>
                <option v-for="group in availableGroups" :key="group" :value="group">
                    {{ group }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>

export default {
    name: 'RegisterFormPartGroup',
    props: {
        label: String,
        availableGroups: Array,
        selectedGroup: String,
    },
    emits: [
        'update:selectedGroup',
    ],
}
</script>
